import { actionTypes } from '../constants/actionTypes';

export const programsDropdownOpen = (state = false, action) => {
  switch (action.type) {
    case actionTypes.PROGRAMS_DROPDOWN_OPEN:
      return action.payload;
  }
  
  return state;
};

export const ordersSearchDisplay = (state = false, action) => {
  switch (action.type) {
    case actionTypes.ORDERS_SEARCH_DISPLAY:
      return action.payload;
  }
  
  return state;
};

export const ordersSearchData = (state = {}, action) => {
  switch (action.type) {
    case actionTypes.ORDERS_SEARCH_DATA:
      return Object.assign({}, state, action.payload);
  }
  return state;
};

export const orderSearch = (state = {}, action) => {
  switch (action.type) {
    case actionTypes.ORDER_SEARCH:
      return Object.assign({}, state, action.payload);
  }

  return state;
};

export const orderSearchPrograms = (state = {}, action) => {
  switch (action.type) {
    case actionTypes.ORDER_SEARCH_PROGRAMS:
      return Object.assign({}, state, action.payload);
  }

  return state;
};

export const searchOrdersList = (state=[], action) => {
  switch (action.type) {
    case actionTypes.SEARCH_ORDERS_LIST:
      return [].concat(action.payload);
  }

  return state;
};

export const recentRangeList = (state = {}, action) => {
  switch (action.type) {
    case actionTypes.RECENT_RANGE_LIST:
      return Object.assign({}, state, action.payload);
  }

  return state;
};

export const selectedRange = (state = {}, action) => {
  switch (action.type) {
    case actionTypes.SELECTED_RANGE:
      return Object.assign({}, state, action.payload);
  }

  return state;
};

export const isRangeDropdownOpen = (state = false, action) => {
  switch (action.type) {
    case actionTypes.IS_RANGE_DROPDOWN_OPEN:
      return action.payload;
  }
  
  return state;
};

export const recentOrdersList = (state = {}, action) => {
  switch (action.type) {
    case actionTypes.RECENT_ORDERS_LIST:
      return action.payload;
  }
  
  return state;
};
